import { Header } from '@cox/core-ui8/dist/Header'

import withAEM from '../../hoc/withAEM'

export default withAEM(Header, { compName: 'Header', atomSpacing: true })
